import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log('🔧 Supabase Config Debug:');
console.log('URL:', supabaseUrl);
console.log('Key:', supabaseAnonKey ? '***' + supabaseAnonKey.slice(-4) : 'undefined');

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables. Please check your .env file.');
}

// Create a client with fallback empty strings
export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || ''); 